<template>
  <div id="videos" v-if="caregroup" v-loading="LOADING">
    <div v-show="!LOADING">
      <div v-if="caregroup.videos.length">
        <!-- <iframe id="ytplayer" type="text/html" :src="'https://www.youtube.com/embed/' + selectedVideo.id + '?autoplay=1'" frameborder="0"
      allowfullscreen/>-->
        <div v-if="selectedVideo.hostingProvider == 'YOUTUBE'">
          <youtube :video-id="selectedVideo.id" :player-vars="playerVars" width="100%"></youtube>
        </div>
        <dynamic-video video-style="width: 100%" v-if="selectedVideo.hostingProvider == 'LOCAL'" :file-id="selectedVideo.id" :options="{ autoplay: true, controls: true}">
        </dynamic-video>
      </div>
      <div class="col-12" v-if="caregroup.videos.length">
        <p class="playing-video-title">{{ selectedVideo.title }}</p>
      </div>

      <div class="videos-list">
        <div v-for="video in caregroup.videos" :key="video._id" class="video-thumbnail">
          <div @click="selectVideo(video)">
            <div class="col-12">
              <div class="row">
                <div class="col-4 col-md-3 col-lg-2">
                  <img v-if="video.hostingProvider == 'YOUTUBE'" :src="video.thumbnailUrl.url" />
                  <dynamic-video video-style="width: 100%" v-if="video.hostingProvider == 'LOCAL'" :file-id="video.id">
                  </dynamic-video>
                </div>
                <div class="col-8 col-md-9 col-lg-10" style="white-space: nowrap; width: 100%; overflow: hidden">
                  <p class="card-heading" style="overflow: hidden; text-overflow: ellipsis">
                    {{ video.title }}
                  </p>
                </div>
              </div>
              <!-- <t style="padding: 5px ">{{video.duration | date: 'H:mm:ss': 'UTC'}}</t> -->
            </div>

            <div class="card-main">
              <div class="card-inner">
                <span style="font-size: 14px;">{{user.duration}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5" v-if="!caregroup.videos || caregroup.videos.length < 1">
          <div class="col-12 text-center">
            <i class="fa fa-info-circle"></i>
            {{ $t("message.No educational videos yet") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "videos",

  components: {},

  created() {
    if (this.caregroup.videos && this.caregroup.videos.length > 0) {
      this.selectedVideo = this.caregroup.videos[0];
    }
  },

  data() {
    return {
      LOADING: true,
      selectedVideo: null,
      playerVars: {
        autoplay: 1,
        modestbranding: 1,
      },
    };
  },

  async mounted() {
    let that = this;
    try {
      let getCaregroups = await this.$store.dispatch("getCaregroups");
      for (let caregroup of getCaregroups.data) {
        if (caregroup.name == "Nutrition") {
          this.$store.commit("setState", {
            stateName: "caregroup",
            stateValue: caregroup,
          });
          break;
        }
      }
      this.selectedVideo = this.caregroup.videos[0];
    } catch (e) {
      console.log(e);
    }
    setTimeout(() => {
      that.LOADING = false;
    }, 2000);
  },

  computed: {
    user() {
      return JSON.parse(localStorage.user);
    },
    caregroup() {
      return this.$store.state.caregroup;
    },
    player() {
      return this.$refs.youtube.player;
    },
  },
  methods: {
    selectVideo(video) {
      this.selectedVideo = video;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
/deep/ iframe {
  width: 100%;
  height: 16em;
}
.video-thumbnail {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}
.playing-video-title {
  font-weight: 600;
  margin-top: 1rem;
}
.videos-list {
  overflow-y: scroll;
  height: 54vh;
}
/deep/.el-loading-spinner {
  position: fixed;
}

/deep/ .el-loading-mask {
  background: #fff !important;
}

@media (min-width: 992px) {
  iframe {
    height: 31em;
  }
}

@media (min-height: 736px) {
  /deep/ iframe {
    height: 35vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 768px) {
  /deep/ iframe {
    height: 40vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 1024px) {
  iframe {
    height: 31em;
  }
  .videos-list {
    height: 46vh;
  }
}
</style>
